import { ClbButton, ClbInputText } from '@celebration/design-system-react'
import { useState } from 'react'
import styled from 'styled-components'
import { requestPurgeQueueDlq } from './purge-queue-dlq.service'
import { useToastContext } from 'hooks/useToastContext'
import intl from 'react-intl-universal'

const Container = styled.section`
  margin: 1em;
  width: 30vw;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;

  .purge-queue-dlq-button {
    margin-left: 5px;
    margin-top: 15px;
  }
`

const PurgeQueueDlq = () => {
  const [queueName, setQueueName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { openToast } = useToastContext()

  const sendRequest = () => {
    if (isLoading)
      return

    setIsLoading(true)

    requestPurgeQueueDlq(queueName)
      .then(() => openToast(intl.get('controlPanel.purgeQueueDlq.purgeSuccess')))
      .catch(() => openToast(intl.get('controlPanel.purgeQueueDlq.purgeFailure'), 'negative'))
      .finally(() => setIsLoading(false))
  }

  return (
    <Container className='purge-queue-dlq-content'>
      <ClbInputText
        size='lg'
        label={intl.get('controlPanel.purgeQueueDlq.inputLabel')}
        placeholder={intl.get('controlPanel.purgeQueueDlq.inputPlaceholder')}
        value={queueName}
        onClbChange={(event) => setQueueName(event.detail.value)}/>
      <ClbButton
        className='purge-queue-dlq-button'
        loading={isLoading}
        onClbClick={sendRequest}>{intl.get('controlPanel.purgeQueueDlq.buttonText')}</ClbButton>
    </Container>
  )
}

export default PurgeQueueDlq
